export default __webpack_public_path__ + "static/media/LinkedIn Learning Network+ Prep 8 Building  a Real World Network.002ef979.webp";